import { DomainTerminology } from 'app/viewmodels/configuration/domain-terminology';
import { FeatureFlag } from 'app/viewmodels/configuration/feature-flag';


/**
 * RemoteConfiguration class contains config data that needs to be retrieved
 * from the API before anything happens in the application.
 */
export class RemoteConfiguration {
  /**
     * The URL of the Identity Service instance to connect to.
     */
  public identityUrl: string;

  /**
     * The URL you get redirected to after login.
     */
  public redirectUrl: string;

  /**
     * The URL to navigate to after logging out of the application.
     * This doesn't actually seem to be used anywhere.
     */
  public postLogoutUrl: string;

  /**
     * Dictionary of feature toggles
     */
  public featureFlags: FeatureFlag[] = new Array<FeatureFlag>();

  public loginProvider: string;

  /**
     * Array of items each of which includes domain and dictionary for its terminology
     */
  public domainTerminologyItems: DomainTerminology[] = new Array<DomainTerminology>();

  /**
   * The count of records to display.
   */
  public recordstoDisplay: number = 50;

  /**
     * Marshals an API reponse into a format usable by the application.
     * @param {any} data The data received from the API.
     * @param {string} appUrl The URL the application is currently hosted on.
     */
  public loadFromJson(data: any, appUrl: string): void {
    this.identityUrl = data.identityUrl;

    this.redirectUrl = appUrl;
    this.postLogoutUrl = appUrl;

    if (data.virtualDirectory) {
      this.redirectUrl += '/' + data.virtualDirectory;
      this.postLogoutUrl += '/' + data.virtualDirectory;
    }

    if (data.featureFlags) {
      this.featureFlags = data.featureFlags;
    }

    if(data.provider){
      this.loginProvider= data.provider;
    }

    if (data.domainTerminologyItems) {
      for (const domainTerminology of data.domainTerminologyItems) {
        const terminology = new DomainTerminology();
        terminology.loadFromJson(domainTerminology);
        this.domainTerminologyItems.push(terminology);
      }
    }
    if (data.recordstoDisplay) {
      this.recordstoDisplay = data.recordstoDisplay;
    }

    this.redirectUrl += '/#/signed-in?';
  }
}
